module.exports = __webpack_public_path__ + "static/hero-phone-2-min-08b5ec082531869cfd61f7bd5dd8674f.png";